module.exports = __webpack_public_path__ + "static/media/platform1.589a6447.jpg";